export default __webpack_public_path__ + "static/media/spinner.bd10573b.svg";